import { useTranslation } from "react-i18next";
import { Navigate, useSearchParams } from "react-router-dom";

import { SetPasswordForm } from "../components/SetPasswordForm";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/v2/card";
import { ROUTES } from "@/constants/routes";

function SetPasswordPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const email = searchParams.get("email");
  const token = searchParams.get("token");

  if (!email || !token) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return (
    <Card className="w-full max-w-lg mx-auto shadow-lg">
      <CardHeader className="space-y-2 pb-4">
        <CardTitle>{t("auth.pages.setPassword.title")}</CardTitle>
        <CardDescription>
          {t("auth.pages.setPassword.description")}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <SetPasswordForm email={email} token={token} />
      </CardContent>
    </Card>
  );
}

export default SetPasswordPage;
